import css from './DonateCheckoutInput.module.css';
import {useState} from 'react';

const DonateCheckoutInput = ({label, defaultType=true, periods=[], inputBorder=[], stylesCss=""}) => {
	const [defaultInputState, setDefaultInputState] = useState('');

	const onInputChange = (e) => {
	    const re = /^[0-9\,\.\b]+$/;

	    // if value is not blank, then test the regex

	    if (e.target.value === '' || re.test(e.target.value)) {
	       setDefaultInputState(e.target.value)
	    }
	}

	return (
		<>
			{
				defaultType ?
					<div className={`flex justify-center items-center ${css.containerDefault} ${stylesCss}`}>
						<p>{label}</p>
						<div className={css.containerDefault__inputContainer}>
							<span className={css.containerDefaultBottom} style={inputBorder[0]}/>
							<input onChange={onInputChange} value={defaultInputState}/>
							<span className={css.containerDefaultTop} style={inputBorder[0]}/>
							<span className={css.containerDefaultRight} style={inputBorder[1]}/>
							<span className={css.containerDefaultLeft} style={inputBorder[1]}/>
						</div>
					</div> :
					<div className={`flex justify-center items-center ${css.containerDropdown} ${stylesCss}`}>
						<p>{label}</p>
						<select>
							{
								periods.map((period, idx) => {
									return <option value={period} key={idx}>{period}</option>
								})
							}
						</select>
					</div>
			}
		</>
	)
}

export default DonateCheckoutInput;
